import React, { Component } from 'react';
import { connect } from 'react-redux';
import './preloader.scss';

class Preloader extends Component {

    render() {
        let { display } = this.props;
        return (
            <div className="cssload-container" style={{display: display ? 'block' : 'none'}}>
                <div className="cssload-arc">
                    <div className="cssload-arc-cube"></div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
     display: state.preloader.display
    }),
    dispatch => ({
    })
)(Preloader);